import { render, staticRenderFns } from "./ChannelTemplate.vue?vue&type=template&id=76ada98c&scoped=true&"
import script from "./ChannelTemplate.vue?vue&type=script&lang=js&"
export * from "./ChannelTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ChannelTemplate.vue?vue&type=style&index=0&id=76ada98c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ada98c",
  null
  
)

export default component.exports